import {
  buildSocialDocumentMeta,
  formatDocumentTitle,
  pageLabelForPathname,
  type SocialDocumentMeta,
} from '@shared/socialDocumentMeta';

export {
  APP_TITLE,
  DEFAULT_META_DESCRIPTION,
  SITE_ORIGIN,
  SOCIAL_PREVIEW_IMAGE_PATH,
  formatDocumentTitle,
  documentTitleForPathname,
  pageLabelForPathname,
  buildSocialDocumentMeta,
  socialPreviewImageUrl,
} from '@shared/socialDocumentMeta';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** Sync tab title + Open Graph / Twitter meta after client navigation. */
export function applyDocumentMeta(meta: SocialDocumentMeta) {
  document.title = meta.title;
  upsertMeta('name', 'description', meta.description);
  upsertMeta('property', 'og:type', 'website');
  upsertMeta('property', 'og:site_name', meta.siteName);
  upsertMeta('property', 'og:title', meta.title);
  upsertMeta('property', 'og:description', meta.description);
  upsertMeta('property', 'og:url', meta.url);
  upsertMeta('property', 'og:image', meta.image);
  upsertMeta('property', 'og:image:secure_url', meta.image);
  upsertMeta('property', 'og:image:type', 'image/png');
  upsertMeta('property', 'og:image:width', String(meta.imageWidth));
  upsertMeta('property', 'og:image:height', String(meta.imageHeight));
  upsertMeta('property', 'og:locale', 'zh_HK');
  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', meta.title);
  upsertMeta('name', 'twitter:description', meta.description);
  upsertMeta('name', 'twitter:image', meta.image);
}

export function applyDocumentMetaForPath(pathname: string, search = '') {
  applyDocumentMetaForRoute(pathname, search);
}

export function applyDocumentMetaForRoute(
  pathname: string,
  search = '',
  pageLabelOverride?: string | null
) {
  const base = buildSocialDocumentMeta(pathname, window.location.origin, search, pageLabelOverride);
  applyDocumentMeta(base);
}
